import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Menu from '../components/Menu';
import axios from 'axios';
import { apiUrl } from '../utils/common';
import { useLocation } from 'react-router-dom';
import Spinner from '../components/Spinner';
import { Button } from '@mui/material';
import Header from '../components/Header'
import ToxicTweet from '../components/ToxicTweet';
import ContentBox from '../components/ContextBox';
import AddRemoveCandidate from '../components/AddRemoveCandidate';


const PageContainer = styled.div`
    margin-top: 50px;
`;

const ContentWrapper = styled.div`
    box-sizing: border-box;
    margin-top: 20px;
    padding: 0 40px;
    margin-bottom: 20px;
`

const CandidateInfoContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  align-items: center;
  margin: 20px 0;
  background: #f7f7f7;
  border-radius: 12px;
  padding: 18px 24px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.07);
`
const CandidateImg = styled.img`
    width: 55px;
    height: 55px;
    border-radius: 50%;
    object-fit: cover;
    border: 1px solid;
`

const SelectedCandidate = () => {
    const location = useLocation();
    const candidateId = location.pathname.split("/")[2];
    const [candidateInfo, setCandidateInfo] = useState(location.state?.candidate);
    const [candidatePostsList, setCandidatePostsList] = useState([]);
    const [loading, setLoading] = useState(true);
    const [postContextData, setPostContextData] = useState({});
    const [visibleCount, setVisibleCount] = useState(4);

    useEffect(() => {
        getCandidatePostsList();
        if (!candidateInfo) {
            fetchCandidateInfo();
        }
    }, [candidateId]);

    const fetchCandidateInfo = async () => {
        const res = await axios.get(`${apiUrl}/candidates/getCandidateById`, {
            params: {
                candidateId
            }
        });
        setCandidateInfo(res.data);
    };

    const getCandidatePostsList = async () => {
        if (candidateId) {
            try {
                const res = await axios.get(`${apiUrl}/candidates/getCandidatePosts`, {
                    params: {
                        candidateId: candidateId,
                    }
                })
                setCandidatePostsList(res.data)
                setLoading(false);
            } catch (err) {
                console.error('Failed to fetch candidate posts: ', err)
            }
        }
    }

    const handleTweetContext = async (postItem) => {
        const postId = postItem._id;

        setPostContextData(prev => ({
            ...prev,
            [postId]: {
                ...(prev[postId] || {}),
                loading: true,
                showButtonContext: false
            }
        }));

        try {
            const response = await axios.post(`${apiUrl}/posts/generateContext`, { post: postItem });
            const data = response.data;

            setPostContextData(prev => ({
                ...prev,
                [postId]: {
                    loading: false,
                    showButtonContext: false,
                    content: data.content ?? '',
                    context: data.context ?? []
                }
            }));
        } catch (error) {
            console.error("Error fetching context:", error);
            setPostContextData(prev => ({
                ...prev,
                [postId]: {
                    ...(prev[postId] || {}),
                    loading: false,
                    showButtonContext: true
                }
            }));
        }
    };

    const handleShowMore = () => {
        setVisibleCount((prev) => prev + 4);
    };

    const groupByTwo = (arr) => {
        const result = [];
        for (let i = 0; i < arr.length; i += 2) {
            result.push(arr.slice(i, i + 2));
        }
        return result;
    };

    return (
        <>
            <Menu />
            <PageContainer>
                <Header title='Selected Candidate Posts' />
                {loading ? (
                    <Spinner />
                ) : (<ContentWrapper>
                    {candidateInfo && (
                        <CandidateInfoContainer>
                            <CandidateImg
                                src={candidateInfo.profile_image_url}
                                alt={candidateInfo.name}
                            />
                            <span style={{ fontWeight: 'bold', fontSize: '1.1em' }}>
                                {candidateInfo.name}
                            </span>
                            <div>
                                <strong>Username: </strong>
                                <a
                                    href={`https://twitter.com/${candidateInfo.username}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ color: '#3498db', textDecoration: 'none', fontWeight: 'bold' }}
                                >
                                    @{candidateInfo.username}
                                </a>
                            </div>
                            <div>
                                <strong>Followings:</strong> {candidateInfo.following}
                            </div>
                            <div>
                                <strong>Followers:</strong> {candidateInfo.followers}
                            </div>
                            <div>
                                <strong>Avg. Toxicity:</strong> {candidateInfo.averageToxicity?.toFixed(2) ?? 'N/A'}
                            </div>
                            <div>
                                <strong>Toxic Post Ratio:</strong> {candidateInfo.toxicPostsCount}/{candidateInfo.totalPosts}
                            </div>
                            <div style={{ display: 'flex', width: '100%' }}>
                                <AddRemoveCandidate candidate={candidateInfo} />
                            </div>
                        </CandidateInfoContainer>
                    )}

                    {candidatePostsList && candidatePostsList.length > 0 && (
                        <div style={{ marginTop: '30px' }}>
                            {groupByTwo(candidatePostsList.slice(0, visibleCount)).map((pair, idx) => (

                                <div key={idx} style={{ display: 'flex', gap: '30px', marginBottom: '30px' }}>
                                    {pair.map((postItem, i) => (
                                        <div key={postItem._id} style={{ flex: 1, padding: '18px', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
                                            <ToxicTweet tweetId={postItem.twitterPostId} />
                                            <div style={{ marginTop: '15px' }}>
                                                <strong>Toxicity Score:</strong> {postItem.toxicScoreMax ?? 'N/A'}
                                            </div>
                                            <div style={{ marginTop: '15px' }}>
                                                {(!postContextData[postItem._id]?.loading && postContextData[postItem._id]?.showButtonContext !== false) && (
                                                    <Button variant='contained' onClick={() => handleTweetContext(postItem)}>
                                                        what is this tweet about?
                                                    </Button>
                                                )}

                                                {postContextData[postItem._id]?.loading && (
                                                    <Spinner />
                                                )}

                                                {(!postContextData[postItem._id]?.loading && postContextData[postItem._id]?.showButtonContext === false) && (
                                                    <ContentBox
                                                        content={postContextData[postItem._id]?.content}
                                                        context={postContextData[postItem._id]?.context}
                                                    />
                                                )}

                                            </div>
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                    )}
                    {visibleCount < candidatePostsList.length && (
                        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                            <Button variant="outlined" onClick={handleShowMore}>
                                Show more posts
                            </Button>
                        </div>
                    )}
                </ContentWrapper>
                )}
            </PageContainer>
        </>
    )
}

export default SelectedCandidate
